import debounce from '../utils/debounce';

export default class Header {
    constructor () {
        this.header = document.querySelector('.site-header');

        if (!this.header) return;

        this.init();
    }

    init () {
        const gthis = this;

        window.addEventListener('scroll', (event) => {
            event.stopPropagation();

            (debounce(function () {
                if (window.scrollY > 100) {
                    gthis.header.classList.add('scrolled');
                } else {
                    gthis.header.classList.remove('scrolled');
                }
            }))();
        });
    }
}